import React from "react";
import Link from 'next/link';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { quotes_helper } from "@/helpers/quotes_helper";
// import { quotes_helper } from "helpers/quotes_helper";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import styles  from './styles.module.scss';
import Body from "@/ui/Body";

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function QuoteSlider() {

    const quotes = quotes_helper.fetch();
    // const quote = { quote: "At Insight, I've thrived on nurturing team growth, notably in establishing our efficient Mission Critical division post-Covid. Guided by leaders like Steve and Mike, I've learned extensively within our supportive environment. ", authorName: 'Andy Rogers', authorRole: 'Business Manager'}
    // const quote2 = { quote: "At Insight, I've thrived on nurturing team growth, notably in establishing our efficient Mission Critical division post-Covid. Guided by leaders like Steve and Mike, I've learned extensively within our supportive environment. ", authorName: 'Roger Gold', authorRole: 'Finance Director'}
    // const quotes = [quote, quote2]
    const breakpoints = {
        500: {
            slidesPerView: 1,
        },
        760: {
            slidesPerView: 1,
        },
        1150: {
            slidesPerView: 1,
        },
        1240: {
            slidesPerView: 1
        }
    };

    return (
    <div id="QuoteSlider" className={`${styles.QuoteSlider}`}>
        <Swiper
            loop
            effect={"slide"}
            speed={1000}
            spaceBetween={10}
            navigation={{ prevEl: '.swiper-job-button-prev', nextEl: '.swiper-job-button-next' }} 
            breakpoints={breakpoints}
        >
            {quotes?.map((quote, index) => (
                <SwiperSlide key={index}>
                    <div className={styles.content}>
                        <div className={styles.profile_image}>
                            <img src={quote.image} alt="profile image"></img>
                        </div>
                        <div className={styles.quote}>
                            <div className={styles.quote_marker}>”</div>
                            <div dangerouslySetInnerHTML={{ __html: quote?.quote }} />
                            <div className={styles.bottom_header}>
                                <div className={styles.author}>
                                    <h6>{quote.author}</h6>
                                    <span>{quote.role}</span>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
        <div className={styles.arrow}>
            <img className={'swiper-job-button-prev'} src="/icons/round-arrow-left.svg" alt="left-arrow"></img>
            <img className={'swiper-job-button-next'} src="/icons/round-arrow-right.svg" alt="right-arrow"></img>
        </div>
    </div>
    )
}



{/* <div className={styles.cont}>
    <div className={styles.profile_img}>
        <img src="/images/placeholders/img-placeholder.jpg" alt="profile"></img>
    </div>
    <div className={styles.quotes}>
        <img src="/icons/quote.svg" alt="quote"></img>
        <div>
            {quote.quote}
        </div>
        <div className={styles.bottom_header}>
            <div className={styles.author}>
                <h6>{quote.authorName}</h6>
                <span>{quote.authorRole}</span>
            </div>
        </div>

    </div>
</div> */}